import { Component, ElementRef, QueryList, ViewChildren, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { ProfileComponent } from '../../pages/setting/profile/profile.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-navigacion',
  standalone: true,
  imports: [
    RouterLink,
    ProfileComponent,
    RouterModule

  ],
  templateUrl: './navigacion.component.html',
  styleUrls: ['./navigacion.component.css']
})
export class NavigacionComponent implements OnInit {
  @ViewChildren('list') listItems!: QueryList<ElementRef>;
  @Input() id: number = 0; // დინამიური id

  constructor(private router: Router) {}

  ngOnInit() {
    // Subscribe to router events
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects;
        // console.log('Link:', currentUrl);
        this.updateActiveLink(currentUrl);
      }
    });
  }

  activeLink(event: Event, link: string) {
    // Remove 'active' class from all elements
    this.listItems.forEach((item) => {
      item.nativeElement.classList.remove('active');
    });

    // Add 'active' class to the clicked element
    const clickedElement = event.currentTarget as HTMLElement;
    clickedElement.classList.add('active');

    // Navigate to the link
    // this.router.navigate([link]);
  }

  private updateActiveLink(currentUrl: string) {
    // console.log('Component ID:', this.id);

    // Check each list item and apply 'active' class if the URL matches
    this.listItems.forEach((item) => {
      const link = item.nativeElement.getAttribute('data-link')?.replace('{{id}}', this.id);
      // console.log('Link from HTML:', link);
      // console.log('Current URL:', currentUrl);
 
      if (link === currentUrl) {
        item.nativeElement.classList.add('active');
      } else {
        item.nativeElement.classList.remove('active');
      }

    });
  }
}